import { render, staticRenderFns } from "./folders-ports-countries-options.vue?vue&type=template&id=0fa4da72&scoped=true"
import script from "./folders-ports-countries-options.vue?vue&type=script&lang=js"
export * from "./folders-ports-countries-options.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fa4da72",
  null
  
)

export default component.exports